import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12 19C15.9494 19 19.5071 16.4547 22 12C19.5071 7.54529 15.9494 5 12 5C8.05064 5 4.49293 7.54529 2 12C4.49293 16.4547 8.05064 19 12 19Z",
  stroke: "currentColor",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12 8.5C13.933 8.5 15.5 10.067 15.5 12C15.5 13.933 13.933 15.5 12 15.5C10.067 15.5 8.5 13.933 8.5 12C8.5 10.067 10.067 8.5 12 8.5Z",
  stroke: "currentColor"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M2 22L22 2",
  stroke: "currentColor"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render: render }